import { api } from "./api";
import { ControlDate } from "../types/controle-datas";
import { dedupedFetch } from "./cache";

/**
 * Busca as datas de controle de forma pública (não requer autenticação)
 * Pode ser usada antes do login
 */
export const fetchControlDatesPublic = async (): Promise<ControlDate[]> => {
  return dedupedFetch("control-dates", async () => {
    const { data } = await api.get('/database/controle_datas__c');

    if (!Array.isArray(data)) {
      return [];
    }

    return data;
  }, 120_000);
};

/**
 * Filtra datas de controle por categoria
 */
export const filterByCategory = (
  dates: ControlDate[],
  category: string
): ControlDate[] => {
  if (!dates || dates.length === 0) return [];

  return dates.filter((data) => {
    if (Array.isArray(data.categoria)) {
      return data.categoria.includes(category) || data.categoria.includes('todas');
    }
    return data.categoria === category || data.categoria === 'todas';
  });
};

/**
 * Verifica se uma data de controle está ativa no momento
 */
export const isDateActive = (date: ControlDate): boolean => {
  const now = new Date();
  const inicio = new Date(date.dataInicio);
  const fim = date.dataFim ? new Date(date.dataFim) : null;

  if (fim) {
    return now >= inicio && now <= fim;
  }

  return now >= inicio;
};

/**
 * Busca as próximas N datas
 */
export const getUpcomingDates = (
  dates: ControlDate[],
  limit: number = 5
): ControlDate[] => {
  if (!dates || dates.length === 0) return [];

  const now = new Date();
  return dates
    .filter((data) => new Date(data.dataInicio) > now)
    .sort((a, b) => new Date(a.dataInicio).getTime() - new Date(b.dataInicio).getTime())
    .slice(0, limit);
};

/**
 * Busca a próxima data importante
 */
export const getNextImportantDate = (dates: ControlDate[]): ControlDate | null => {
  const upcoming = getUpcomingDates(dates, 1);
  return upcoming.length > 0 ? upcoming[0] : null;
};
